module.exports = __webpack_public_path__ + "img/mono-cicle.312af071.svg";